// Authentication utilities for admin access

const ADMIN_CREDENTIALS = {
  username: 'admin',
  password: '3bconsulting'
};

const AUTH_TOKEN_KEY = 'admin_auth_token';

// Generate a simple auth token
const generateAuthToken = (): string => {
  return btoa(`${ADMIN_CREDENTIALS.username}:${Date.now()}`);
};

// Authenticate admin user
export const authenticateAdmin = (username: string, password: string): boolean => {
  if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
    const token = generateAuthToken();
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    return true;
  }
  return false;
};

// Check if user is authenticated
export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  return !!token;
};

// Logout admin user
export const logoutAdmin = (): void => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

// Get auth token
export const getAuthToken = (): string | null => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};
